import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  height: 64px;
  background-color: #ffffff;
  border-bottom: 1px solid #eaeff1;
  width: 100%;
  position: sticky;
  top: 0;
`;

export { Container };
